import styles from './Badge.module.css';
import classNames from 'classnames';

interface Props {
  variant?: 'default' | 'danger' | 'success' | 'warning';
  label: string;
}

export function Badge({ label, variant = 'default' }: Props) {
  return <span className={classNames(styles.badge, styles[`variant-${variant}`])}>{label}</span>;
}
